import { render, staticRenderFns } from "./WorkSection.vue?vue&type=template&id=76a08688&scoped=true&"
import script from "./WorkSection.vue?vue&type=script&lang=js&"
export * from "./WorkSection.vue?vue&type=script&lang=js&"
import style0 from "./WorkSection.vue?vue&type=style&index=0&id=76a08688&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76a08688",
  null
  
)

export default component.exports